import React from "react";

export default function ToggleIcon({
    fillColor = 'var(--color-text-dark)',
    toggled = false,
    height = 20,
    width = 20
}) {
    return (
        <svg fill={fillColor} height={height} width={width} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 185.344 185.344">
            <g style={{
                transform: `rotate(${toggled ? '180' : '0'}deg)`,
                transformOrigin: "center",
                transition: "transform .3s"
            }}>
                <path fill={fillColor} d="M92.672,144.373c-2.752,0-5.493-1.044-7.593-3.138L3.145,59.301c-4.194-4.199-4.194-10.992,0-15.18 c4.194-4.199,10.987-4.199,15.18,0l74.347,74.341l74.347-74.341c4.194-4.199,10.987-4.199,15.18,0 c4.194,4.194,4.194,10.981,0,15.18l-81.939,81.934C98.166,143.329,95.419,144.373,92.672,144.373z"/>
            </g>
        </svg>
    )
}
